import '.w{position:fixed;}.ssr-plugin'
import '.dv{top:0px;}.ssr-plugin'
import '.b4{left:0px;}.ssr-plugin'
import '.b5{right:0px;}.ssr-plugin'
import '.fe{bottom:0px;}.ssr-plugin'
import '.gl{background-color:rgba(0, 0, 0, 0.25);}.ssr-plugin'
import '.gm{z-index:998;}.ssr-plugin'
import '.gn{transition:opacity 0.3s ease;}.ssr-plugin'
import '.o{height:100vh;}.ssr-plugin'
import '.q{width:100%;}.ssr-plugin'
import '.ah{background-color:var(--palette-white);}.ssr-plugin'
import '.go{transition:transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);}.ssr-plugin'
import '.gp{z-index:999;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.f{align-items:center;}.ssr-plugin'
import '.r{justify-content:space-between;}.ssr-plugin'
import '.bn{padding:1.5rem;}.ssr-plugin'
import '.gq{border-bottom:var(--border-default);}.ssr-plugin'
import '.bu{flex-shrink:0;}.ssr-plugin'
import '.bw{flex:1;}.ssr-plugin'
import '.av{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { IconButton } from '@app/components/core/button/IconButton'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { PropsWithChildren } from 'react'
import useMediaQuery from '@app/util/useMediaQuery'

export interface DrawerProps extends PropsWithChildren {
  title: string
  open: boolean
  setOpen: (open: boolean) => void
  portal?: HTMLElement
  style?: Style
  side: 'left' | 'right'
}

export const Drawer = ({
  title,
  open,
  setOpen,
  children,
  portal: _portal,
  style,
  side,
}: DrawerProps) => {
  const isMobile = useMediaQuery()

  const translateValue = open ? '0' : side === 'left' ? '-100%' : '100%'

  return (
    <>
      {/* Overlay */}
      <div className="w dv b4 b5 fe gl gm gn"
        onClick={() => setOpen(false)}
        style={{
          opacity: open ? 1 : 0,
          pointerEvents: open ? 'auto' : 'none',}}
      />

      {/* Sidebar Panel */}
      <styled.div className="w dv o q ah go gp a e"
        style={{
          [side]: 0,
          maxWidth: isMobile ? '100%' : '30rem',
          borderRadius: isMobile ? 0 : '1.25rem',
          boxShadow: open ? '0 0 15px rgba(0,0,0,0.15)' : 'none',
          transform: `translateX(${translateValue})`,
          ...style,
        }}
      >
        {/* Header */}
        <div className="a f r bn gq bu"
        >
          <Title.H4 style={{ margin: 0 }}>{title}</Title.H4>
          <IconButton
            icon={faXmark}
            size="small"
            variant="secondary"
            onClick={() => setOpen(false)}
          />
        </div>

        {/* Content */}
        <div className="bw av bn"
        >
          {children}
        </div>
      </styled.div>
    </>
  )
}
